"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getContainerDOM;
var dom = null;

function getContainerDOM() {
  if (!dom) {
    dom = document.createElement('div');
    document.body.appendChild(dom);
  }

  return dom;
}